var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "operating-input",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.editTaskName()
        }
      }
    },
    [
      _c("div", {
        staticClass: "icon-util edit-task-icon",
        staticStyle: { float: "left", position: "relative", top: "2px" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "operating-input-position", attrs: { id: "syncName" } },
        [
          !_vm.inputShow
            ? _c("div", { staticClass: "task-name" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.inputShow
            ? _c("div", { staticClass: "edit-task" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value"
                    }
                  ],
                  ref: "transferInput",
                  staticClass: "edit-input",
                  attrs: { onfocus: "this.select()" },
                  domProps: { value: _vm.value },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    },
                    blur: function($event) {
                      return _vm.submitTaskName()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.value = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "task-input-icon" }, [
                  _c("i", {
                    staticClass: "icon-util name-sure",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.submitTaskName()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "icon-util name-cancel name-cancel-position",
                    on: {
                      mousedown: function($event) {
                        return _vm.cancelTaskName()
                      }
                    }
                  })
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28ce1104", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ce1104","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/input/edit_input.vue
// module id = null
// module chunks = 